// Dropify 初始化
function initDropify() {
  $('.dropify').each(function () {
    if (!$(this).hasClass('dropify-initialized')) {
      var drBizEvent = $(this).dropify({
        messages: {
          default: '拖拉檔案到這裡，或點擊本區塊後選擇檔案上傳',
          replace: '拖拉新檔案或再次點擊，可替換其他檔案',
          remove: '移除',
          error: '出錯了，請重新整理頁面'
        },
        error: {
          'fileSize': '檔案太大超過 {{ value }}',
          'imageFormat': '僅支援格式為 ({{ value }} 的檔案).',
          'fileExtension': '僅支援格式為 ({{ value }} 的檔案).'
        }
      });

      drBizEvent.on('dropify.afterClear', function (event, element) {
        const fullName = element.input.attr('name');
        if (!fullName) {
          return;
        }
        // 提取 fullName [] 中的內容, article[image] => image
        const matches = [...fullName.matchAll(/\[([^\]]+)\]/g)].map(m => m[1]);
        let attr_name;
        if (matches.length === 1) {
          attr_name = matches[0]; // 只有一層，article[image] => image
        } else {
          attr_name = matches.join('_'); // 一層以上，例如 quarterly_report[tw_document_attributes][file] => tw_document_attributes_file
        }
        $('<input>').attr({
          type: 'hidden',
          id: 'destroy_' + attr_name,
          name: 'destroy_' + attr_name
        }).appendTo('form');
      });

      $(this).addClass('dropify-initialized');
    }
  });
}

// 當頁面載入完成時初始化 dropify
document.addEventListener('DOMContentLoaded', function () {
  initDropify();
});

// 監聽 cocoon 事件，當新增欄位時重新初始化 dropify
document.addEventListener('DOMContentLoaded', function () {
  $('#figures, .dropify-init').each(function () {
    $(this).on('cocoon:after-insert', function () {
      initDropify();
    });

    // 只有 figures 相關的元素需要確認對話框
    if ($(this).is('#figures, #figures_en')) {
      $(this).on('cocoon:before-remove', function (e, task) {
        if (!confirm('確定要刪除嗎？')) {
          e.preventDefault();
          return false;
        }
        // 允許刪除的動畫
        $(this).data('remove-timeout', 500);
        task.fadeOut();
      });
    }
  });
});
